import { render, staticRenderFns } from "./SummarySystemV3.vue?vue&type=template&id=123ef60e&scoped=true"
import script from "./SummarySystemV3.vue?vue&type=script&lang=js"
export * from "./SummarySystemV3.vue?vue&type=script&lang=js"
import style0 from "./SummarySystemV3.vue?vue&type=style&index=0&id=123ef60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123ef60e",
  null
  
)

export default component.exports